<ion-searchbar
  #getmSearchbar
  mode="md"
  debounce="400"
  [animated]="false"
  clearIcon="close-outline"
  searchIcon="getm-search-outline"
  autocomplete="off"
  [placeholder]="'Labels.what-going-buy-today' | translate"
  enterkeyhint="search"
  class="getm-search-component ion-no-padding"
  [ngClass]="{ 'has-value': searchProduct.length > 0 }"
  (ionFocus)="ionFocusSearch($event, getmSearchbar)"
  (ionBlur)="ionBlurSearch(getmSearchbar)"
  (ionInput)="onSearchChange($event)"
  (ionClear)="onClearSearch($event)"
  [(ngModel)]="searchProduct"
></ion-searchbar>

<!-- ! Lista superpuesta de SKUs filtrados -->
<ion-popover
  #popoverGETMSearchProduct
  [isOpen]="showSkuList && searchProduct.length > 0"
  animated="true"
  keyboardClose="false"
  showBackdrop="true"
  translucent="false"
  backdropDismiss="true"
  size="cover"
  (willDismiss)="showSkuList = false"
  (didDismiss)="showSkuList = false"
  class="getm-popover-search-product"
>
  <ng-template>
    <ion-content color="getm-background-light-blue" class="content-list-result">
      <ng-container
        *ngIf="
          products
            | filtro : searchProduct : 'descripcion' as productosFiltrados
        "
      >
        <ng-container *ngIf="productosFiltrados.length > 0; else noResults">
          <ng-container
            *ngFor="let product of productosFiltrados | slice : 0 : 5"
          >
            <getm-search-result-item
              [nombre]="product.title"
              [variante]="('Labels.taste' | translate) + ': ' + product.sku"
              [search]="searchProduct"
              [iconEnd]="'arrow-forward'"
              [imagenThumbnail]="product.imagen"
              (itemClick)="onProductSelected(product, getmSearchbar)"
            ></getm-search-result-item>
          </ng-container>

          <!-- * Coincidencias -->
          <ng-container *ngIf="productosFiltrados.length > 5">
            <ion-item
              mode="md"
              color="transparent"
              lines="none"
              button
              class="getm-item-search-more ion-text-center"
              (click)="goAllMatches(getmSearchbar)"
            >
              <ion-label color="getm-primary-default" class="go-to-all-matches">
                {{ 'Labels.go-to-all-matches' | translate }}

                <ion-icon
                  name="chevron-forward"
                  color="getm-primary-default"
                  class="getm-item-icon-more"
                ></ion-icon>
              </ion-label>
            </ion-item>
          </ng-container>
        </ng-container>

        <ng-template #noResults>
          <getm-search-no-results
            [search]="searchProduct"
            variant="compact"
          ></getm-search-no-results>
        </ng-template>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-popover>

<!-- ! Lista de SKUs recientes -->
<ion-popover
  #popoverGETMSearchRecent
  [isOpen]="showRecentList && recentSearchs.length > 0"
  animated="true"
  keyboardClose="false"
  showBackdrop="true"
  translucent="false"
  backdropDismiss="true"
  size="cover"
  (willDismiss)="showRecentList = false"
  (didDismiss)="showRecentList = false"
  class="getm-popover-search-product"
>
  <ng-template>
    <ion-content color="getm-background-light-blue" class="content-list-result">
      <ion-item
        mode="md"
        color="transparent"
        lines="none"
        class="getm-item-search-more"
      >
        <ion-label color="getm-neutral-dark" class="recent">
          {{ 'Labels.recent' | translate }}
        </ion-label>
      </ion-item>

      <ng-container *ngFor="let product of recentSearchs">
        <getm-search-result-item
          [nombre]="product.title"
          [variante]="('Labels.taste' | translate) + ': ' + product.sku"
          [search]="searchProduct"
          [iconEnd]="'arrow-forward'"
          [imagenThumbnail]="product.imagen"
          (itemClick)="onProductSelected(product, getmSearchbar)"
        ></getm-search-result-item>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-popover>
